module.exports = __webpack_public_path__ + "img/invalid-part.613e444f.png";